var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.225 0.981699L4 1.42857H1C0.446875 1.42857 0 1.87545 0 2.42857C0 2.9817 0.446875 3.42857 1 3.42857H13C13.5531 3.42857 14 2.9817 14 2.42857C14 1.87545 13.5531 1.42857 13 1.42857H10L9.775 0.981699C9.60625 0.641074 9.25938 0.428574 8.88125 0.428574H5.11875C4.74063 0.428574 4.39375 0.641074 4.225 0.981699ZM13 4.42857H1L1.6625 15.0223C1.7125 15.8129 2.36875 16.4286 3.15938 16.4286H10.8406C11.6313 16.4286 12.2875 15.8129 12.3375 15.0223L13 4.42857Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSolid);
export default __webpack_public_path__ + "static/media/trash-solid.74e5c2858528128b158f52adbf3868c9.svg";
export { ForwardRef as ReactComponent };